// src/services/loginService.js
import axiosInstance from './ApiService';

export const signInMock = async (username, password, cancelToken) => {
  try {
    const response = await axiosInstance.post(
      '/users/login',
      { username, password },
      { cancelToken }
    );
    return {
      "IdToken": response.data.authToken,
      "AccessToken": response.data.authToken,
      "RefreshToken": response.data.authToken,
      "Username": response.data.authToken
    }
  } catch (error) {
    throw error;
  }
};
